import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'

import {
  DEFAULT_PLAN_SKU,
  NEAT_AI_YEARLY_SKU,
  NEAT_HOME_TRIAL_SKU,
  NEAT_HOME_VIP_YEARLY_SKU,
  NEAT_HOME_YEARLY_SKU,
  NEAT_VIP_YEARLY_SKU,
  TRIAL_SKU,
} from '@/constants'

import styles from './SignUp.module.scss'

const getMessageId = id => `pages.signUp.form.authenticate.heading.${id}`

export const BUY_NEAT = 'buyNeat'
export const TRIAL_NEAT = 'trialNeat'
export const BUY_NEAT_HOME = 'buyNeatHome'
export const TRIAL_NEAT_HOME = 'trialNeatHome'

// Every sign-up heading a SKU can produce is reachable from this one map. The
// SKUs are named constants rather than inline literals so a SKU-wide grep
// finds them.
export const SKU_VARIANTS = {
  [DEFAULT_PLAN_SKU]: BUY_NEAT,
  [NEAT_VIP_YEARLY_SKU]: BUY_NEAT,
  [NEAT_AI_YEARLY_SKU]: BUY_NEAT,
  [TRIAL_SKU]: TRIAL_NEAT,
  [NEAT_HOME_YEARLY_SKU]: BUY_NEAT_HOME,
  [NEAT_HOME_VIP_YEARLY_SKU]: BUY_NEAT_HOME,
  [NEAT_HOME_TRIAL_SKU]: TRIAL_NEAT_HOME,
}

// `subheadingId` is an explicit per-variant slot, not something inferred from
// the shape of the copy: only the variant the design covers carries one, and
// the rest render the heading alone.
export const HEADING_VARIANTS = {
  [BUY_NEAT]: { headingId: 'buyNeat', subheadingId: null },
  [TRIAL_NEAT]: { headingId: 'trialNeat', subheadingId: 'trialNeatSubhead' },
  [BUY_NEAT_HOME]: { headingId: 'buyNeatHome', subheadingId: null },
  [TRIAL_NEAT_HOME]: { headingId: 'trialNeatHome', subheadingId: null },
}

// Named rich-text slots in place of positional children: the emphasised words
// and the line breaks are tagged inside the copy, so a translation can move
// them without the markup having to agree about child order.
const richText = {
  em: chunks => <span>{chunks}</span>,
  br: () => <br />,
}

const SignUpHeading = ({ plan }) => {
  const variant = HEADING_VARIANTS[SKU_VARIANTS[plan?.sku]]

  if (!variant) {
    return null
  }

  return (
    <>
      <h2 className="text-center">
        <FormattedMessage
          id={getMessageId(variant.headingId)}
          values={richText}
        />
      </h2>
      {variant.subheadingId && (
        <p className={`text-center ${styles.headingSubhead}`}>
          <FormattedMessage
            id={getMessageId(variant.subheadingId)}
            values={richText}
          />
        </p>
      )}
    </>
  )
}

SignUpHeading.propTypes = {
  plan: PropTypes.shape({ sku: PropTypes.string }),
}

export default SignUpHeading
